export default {
	data() {
		return {
			filterProduct: {
				name: "",
				_id: ""
			}
		};
	},
	watch: {
		"filterProduct._id": {
			handler(val) {
				let fieldName = "product_color";
				if (val !== "") {
					this.$set(this.kvFilter, fieldName, { k: fieldName, t: "id", v: val });
				} else {
					this.$delete(this.kvFilter, fieldName);
				}
			},
			immediate: true
		}
	}
};
